export namespace Colors {
  export const HolidayBackGroundColor = "#ffb8b8";
  export const SaturdayBackGroundColor = "#b8ccff";
}
